import { render, staticRenderFns } from "./CampusSelectboxNoCache.vue?vue&type=template&id=4aeffceb"
import script from "./CampusSelectboxNoCache.vue?vue&type=script&lang=js"
export * from "./CampusSelectboxNoCache.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports